import I from"react";import{Link as B}from"react-router-dom";import{forwardRef as k,createElement as P}from"react";var i=e=>e.replace(/([a-z0-9])([A-Z])/g,"$1-$2").toLowerCase(),g=e=>e.replace(/^([A-Z])|[\s-_]+(\w)/g,(a,t,u)=>u?u.toUpperCase():t.toLowerCase()),r=e=>{let a=g(e);return a.charAt(0).toUpperCase()+a.slice(1)},l=(...e)=>e.filter((a,t,u)=>!!a&&a.trim()!==""&&u.indexOf(a)===t).join(" ").trim(),c=e=>{for(let a in e)if(a.startsWith("aria-")||a==="role"||a==="title")return!0};import{forwardRef as w,createElement as p}from"react";var n={xmlns:"http://www.w3.org/2000/svg",width:24,height:24,viewBox:"0 0 24 24",fill:"none",stroke:"currentColor",strokeWidth:2,strokeLinecap:"round",strokeLinejoin:"round"};var L=w(({color:e="currentColor",size:a=24,strokeWidth:t=2,absoluteStrokeWidth:u,className:f="",children:o,iconNode:x,...s},C)=>p("svg",{ref:C,...n,width:a,height:a,stroke:e,strokeWidth:u?Number(t)*24/Number(a):t,className:l("lucide",f),...!o&&!c(s)&&{"aria-hidden":"true"},...s},[...x.map(([S,h])=>p(S,h)),...Array.isArray(o)?o:[o]]));var m=(e,a)=>{let t=k(({className:u,...f},o)=>P(L,{ref:o,iconNode:a,className:l(`lucide-${i(r(e))}`,`lucide-${e}`,u),...f}));return t.displayName=r(e),t};var A=[["path",{d:"m12 19-7-7 7-7",key:"1l729n"}],["path",{d:"M19 12H5",key:"x3x0zl"}]],d=m("arrow-left",A);var D=({to:e,children:a="Back to Dashboard",className:t="","data-id":u})=>I.createElement(B,{to:e,className:`inline-flex items-center text-gray-400 hover:text-white mb-4 transition-colors ${t}`,"data-id":u},I.createElement(d,{size:16,className:"mr-2","aria-hidden":"true"}),a);export{D as BackLink};
/*! Bundled license information:

lucide-react/dist/esm/shared/src/utils.js:
  (**
   * @license lucide-react v0.522.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/defaultAttributes.js:
  (**
   * @license lucide-react v0.522.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/Icon.js:
  (**
   * @license lucide-react v0.522.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/createLucideIcon.js:
  (**
   * @license lucide-react v0.522.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/icons/arrow-left.js:
  (**
   * @license lucide-react v0.522.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/lucide-react.js:
  (**
   * @license lucide-react v0.522.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)
*/
//# sourceMappingURL=index.js.map
